module.exports = __webpack_public_path__ + "static/media/filter.258b4ecc.png";